import React from 'react';
import { RELEASE_LABEL } from '../../config/release';
import { useSystemFlag } from '../../config/useSystemFlags';
import { getAppMarket } from '../../services/MarketService';

const Footer: React.FC = () => {
  const releaseVisible = useSystemFlag('releaseFooter');
  // F-308: /features is the UK PRS marketing page and the DPA is a UK/EU
  // data-processing agreement — neither belongs on a Texas surface.
  const isTexas = getAppMarket() === 'texas';
  return (
    <footer className="bg-black border-t border-white/5 pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <h3 className="font-bold text-xl text-white">Landlord Pro</h3>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Professional compliance management for landlords. Powered by Compliance Engine Ltd.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-white uppercase tracking-wider text-xs">Product</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              {!isTexas && <li><a href="/features" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Features</a></li>}
              <li><a href="#pricing" className="hover:text-white transition-colors">Pricing</a></li>
              <li><a href="/dashboard" className="hover:text-white transition-colors">Dashboard</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-white uppercase tracking-wider text-xs">Company</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li><a href="https://compliance-engine.io" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Compliance Engine</a></li>
              <li><a href="mailto:admin@compliance-engine.io" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-6 text-white uppercase tracking-wider text-xs">Stay Updated</h4>
            <p className="text-sm text-slate-400 mb-4">Get compliance updates and tips for landlords.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Work email"
                className="flex-1 bg-white/5 border border-white/10 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-emerald-600"
              />
              <button className="bg-emerald-600 px-4 py-2 rounded-lg text-sm font-bold hover:bg-emerald-700 transition-colors text-white">Join</button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-[10px] text-slate-500 uppercase tracking-widest font-bold">
          <div className="flex flex-col items-center md:items-start gap-1">
            <p>© 2026 Compliance Engine Ltd. All rights reserved.</p>
            {releaseVisible && (
              <p className="text-slate-600 normal-case tracking-normal font-normal text-[10px]">{RELEASE_LABEL}</p>
            )}
          </div>
          <div className="flex flex-wrap gap-8 justify-center">
            <a href="/privacy-policy.html" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="/terms-of-service.html" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="/cookie-policy.html" className="hover:text-white transition-colors">Cookie Policy</a>
            <a href="/security" className="hover:text-white transition-colors">Security</a>
            {!isTexas && <a href="/dpa-template.html" className="hover:text-white transition-colors">DPA Template</a>}
            <a href="/data-exit-policy.html" className="hover:text-white transition-colors">Data Exit Policy</a>
            <a href="/refund-policy.html" className="hover:text-white transition-colors">Refund Policy</a>
            <a href="/lia.html" className="hover:text-white transition-colors">LIA</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
